import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { KCL_DISPLAY_SETTINGS } from 'features/common/acl/constants';
import Settings from 'pages/Settings';

import PageLayout from '../components/PageLayout';

const SettingsPage = () => (
	<PageLayout>
		<div className="Page-main">
			<AccessControl accessLevel={KCL_DISPLAY_SETTINGS} showAccessDenied>
				<Settings />
			</AccessControl>
		</div>
	</PageLayout>
);

export default SettingsPage;
